import { FC } from 'react';
import {
  formatKidTemplateFundId,
  formatKidTemplateFundName,
  formatKidTemplateShareClassName,
  KidTemplateFundDisplaySource,
  KidTemplateShareClassDisplaySource,
} from '../templateDocumentRows.utils';

type TemplateDocumentMetaProps = {
  templateName?: string | null;
  document: KidTemplateFundDisplaySource &
    KidTemplateShareClassDisplaySource & {
      share_class_isin?: string | null;
    };
  className?: string;
};

const MetaItem: FC<{ label: string; value: string; mono?: boolean }> = ({
  label,
  value,
  mono = false,
}) => (
  <span title={value}>
    <span className="font-semibold text-gray-500">{label}:</span>{' '}
    <span className={mono ? 'font-mono' : undefined}>{value}</span>
  </span>
);

const TemplateDocumentMeta: FC<TemplateDocumentMetaProps> = ({
  templateName,
  document,
  className = '-mt-2 mb-4 text-xs leading-snug text-gray-900',
}) => {
  const fundId = formatKidTemplateFundId(document);
  const fundName = formatKidTemplateFundName(document);
  const shareClassName = formatKidTemplateShareClassName(document);
  const isin = document.share_class_isin?.trim();
  const items = [
    templateName?.trim()
      ? { label: 'Template', value: templateName.trim() }
      : null,
    { label: 'Fund ID', value: fundId },
    { label: 'Fund Name', value: fundName },
    { label: 'Share class', value: shareClassName },
    isin ? { label: 'ISIN', value: isin, mono: true } : null,
  ].filter(Boolean) as { label: string; value: string; mono?: boolean }[];

  return (
    <p className={className}>
      {items.map((item, index) => (
        <span key={item.label}>
          {index > 0 ? (
            <span className="mx-1.5 text-gray-400" aria-hidden>
              ·
            </span>
          ) : null}
          <MetaItem label={item.label} value={item.value} mono={item.mono} />
        </span>
      ))}
    </p>
  );
};

export default TemplateDocumentMeta;
